module.exports = __webpack_public_path__ + "static/media/ziaruldeiasi.483b7054.png";